import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    updateKiosk
} from '../utils/Actions';

const Kiosk = () => { // that component obtains the correct URL for Calendly in GTA and ensures Calendly after redirect

    const dispatch = useDispatch();
    const navigate = useNavigate(); // that hook is used to navigate to the home page after the state is updated

    useEffect(() => {

        (async () => {
            try {
                dispatch(updateKiosk(true));

                await navigator.serviceWorker.ready; // wait for SW to be ready
                if (!navigator.serviceWorker.controller) // wait for SW to control the page
                    await new Promise(resolve =>
                        navigator.serviceWorker.addEventListener(
                            "controllerchange",
                            resolve,
                            { once: true }
                        )
                    );
                navigator.serviceWorker.controller.postMessage({ type: "KIOSK" }); // send SW a message that app is in kiosk mode
            } catch (err) {
                console.error("Failed to initialize kiosk mode:", err);
            };
            
            navigate('/', { replace: true }); // redirect home — only after kiosk initialization is done
        })();

    }, []);

    return null;
};

export default Kiosk;